import axios from "../axios/axios";
import { setShareholders } from "../store/actions/shareholderAction";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { errorDispatcher } from "../helpers";

export const apiGetShareholders = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("shareholders", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setShareholders(response.data.shareholders));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddShareholder = (form, token) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  axios
    .post(
      "/shareholders",
      { shareholders: form },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      dispatch(apiGetShareholders(token));
      dispatch(apiSetAlert(response.data.message, "success"));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
